import { collection, addDoc, Timestamp } from "firebase/firestore";
import { Profile } from "../models/Profile";
import { db } from "../firebase";
import { getSubdomainFromUrl } from "../utils/url";

const profileCollectionRef = (tenantId: string, matterId: string) =>
  collection(db, "tenants", tenantId, "matters", matterId, "profiles");

export const ProfileService = {
  async createProfile(
    matterId: string,
    profileData: Omit<Profile, "_id" | "createdAt" | "updatedAt">,
  ): Promise<string> {
    const newProfile: Omit<Profile, "_id" | "createdAt" | "updatedAt"> = {
      ...profileData,
    };
    const tenantId = getSubdomainFromUrl(window.location.href);
    const profileRef = await addDoc(
      profileCollectionRef(tenantId, matterId),
      newProfile,
    );
    return profileRef.id;
  },
};
